// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationSellerProtectionPath = 'M75.4 24.045V24h-7a7.4 7.4 0 01-14.8 0h-7a7.2 7.2 0 01-7.4 6.9 7.2 7.2 0 01-7.4-6.9h-7v.1a7.2 7.2 0 01-7.4 6.9 7.2 7.2 0 01-7.3-6.2L16.8 12H85l5.1 12.7a7.4 7.4 0 01-14.7-.6v-.055zm-3.548 9.04A14.17 14.17 0 0082.8 38c.782 0 1.55-.062 2.3-.18V79h-7v7h14V34.67c3.113-2.563 5.1-6.368 5.1-10.57v-.7L89.7 5H12.6L3 23.2v.9c0 4.202 1.987 8.007 5.1 10.57V86h13v-7h-6V37.82a14.7 14.7 0 002.3.18 14.17 14.17 0 0010.948-4.914A14.607 14.607 0 0039.2 37.9c4.336 0 8.25-1.898 10.9-4.867A14.606 14.606 0 0061 37.9c4.31 0 8.204-1.875 10.852-4.814zM58 60v-6.5a8 8 0 10-16 0V60h16zm-23 0v-6.5c0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15V60h8v22.4a7.9 7.9 0 01-1.7 4.9l-5.8 7.6a8.1 8.1 0 01-6.3 3.1H40.8a8.1 8.1 0 01-6.3-3.1l-5.8-7.6a7.9 7.9 0 01-1.7-4.9V60h8zm19.8 13.9a4.884 4.884 0 01-1.4 3.43v8.71h-7v-8.71a4.9 4.9 0 118.4-3.43zM34 67v15.4a1.4 1.4 0 00.2.6l5.8 7.6a.9.9 0 00.8.4h18.4a.9.9 0 00.8-.4l5.8-7.6a1.4 1.4 0 00.2-.6V67H34z';
var IllustrationSellerProtection = baseIllustration('IllustrationSellerProtection', {
  getPath: () => IllustrationSellerProtectionPath
}, 'ColoredIllustrationSellerProtection');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationSellerProtection;
//# sourceMappingURL=index.js.map